import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';


class DeviceAudioOverview extends Component {
  render() {
    const { device } = this.props;
    const { latestBillingPeriod } = device.currentSubscription;
    const {
      periodStart, periodEnd,
    } = latestBillingPeriod;

    const periodStartFormatted = moment(periodStart).local().format('DD MMM');
    const periodEndFormatted = moment(periodEnd).local().format('DD MMM');

    return (
      <div className="btnlist">

        <div className="btnlist__content">
          <div className="btnlist__title">
            Live Audio
          </div>
          <div className="btnlist__subtitle">
            <span>Minutes</span>
            <span className="small-text">{periodStartFormatted} until {periodEndFormatted}</span>
          </div>

          <BillingPeriodSummary billingPeriod={latestBillingPeriod} />

        </div>
        <Link
          to={{
            pathname: `/m/devices/${device.id}/call-log`,
            state: { origin: 'device_audio_overview' },
          }}
          className="btnlist__btn">
          <span className="btnlist__label">Audio Log</span>
          <span className="btnlist__icon">
            <i className="fa fa-chevron-right"></i>
          </span>
        </Link>

        <Link
          to={{
            pathname: `/m/devices/${device.id}/purchase-audio-minutes`,
            state: { origin: 'device_audio_overview' },
          }}
          className="btnlist__btn">
          <span className="btnlist__label">Purchase Minutes</span>
          <span className="btnlist__icon">
            <i className="fa fa-chevron-right"></i>
          </span>
        </Link>
      </div>
    );
  }
}

DeviceAudioOverview.propTypes = {
  device: PropTypes.object.isRequired,
};

function BillingPeriodSummary(props) {
  const {
    totalMinutes,
    usedMinutes,
    availableMinutes,
  } = props.billingPeriod;

  const usedPercent = `${(usedMinutes / totalMinutes) * 100}%`;

  return (
    <div className="audio-balance">
      <div className="audio-balance-counters">
        <div className="audio-balance__box">
          <p className="audio-balance__title">
            {usedMinutes}
          </p>
          <p className="audio-balance__subtitle">
            Used
          </p>
        </div>

        <div className="audio-balance__box">
          <p className="audio-balance__title">
            {availableMinutes}
          </p>
          <p className="audio-balance__subtitle">
            Remaining
          </p>
        </div>

        <div className="audio-balance__box">
          <p className="audio-balance__title">
            {totalMinutes}
          </p>
          <p className="audio-balance__subtitle">
            Total
          </p>
        </div>
      </div>


      <div className="audio-balance-bar">
        <div className="audio-balance-bar__left" style={{ width: usedPercent }}></div>
        <div className="audio-balance-bar__right"></div>
      </div>
    </div>
  );
}


export default DeviceAudioOverview;
